export default __webpack_public_path__ + "static/media/ProfilePic.6ee3f11c.jpg";